// Learning Center API client.
// The Learning Center opens in its own browser tab, and the app keeps its JWT in
// per-tab sessionStorage — so a fresh tab has no token. The opener passes the
// token in the URL hash (#t=...). We capture it once, keep it for this tab, and
// strip the hash so it isn't left in the address bar.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

let TOKEN = sessionStorage.getItem("revq.token") || "";

(function captureHashToken() {
  const h = window.location.hash || "";
  const m = h.match(/[#&]t=([^&]+)/);
  if (m) {
    TOKEN = decodeURIComponent(m[1]);
    try { sessionStorage.setItem("revq.token", TOKEN); } catch (e) { /* ignore */ }
    const clean = window.location.pathname + window.location.search;
    window.history.replaceState(null, "", clean);
  }
})();

export function hasToken() {
  return !!TOKEN;
}

// Deep-link into an app module from the Learning Center, carrying this tab's
// session so the new tab opens already signed in.
export function openModule(path) {
  const url = `${path}${TOKEN ? `#t=${encodeURIComponent(TOKEN)}` : ""}`;
  window.open(url, "_blank", "noopener");
}

async function call(path, { method = "GET", body } = {}) {
  const res = await fetch(`${BACKEND}/api/learning${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(TOKEN ? { Authorization: `Bearer ${TOKEN}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    const e = new Error("Sign in required");
    e.code = 401;
    throw e;
  }
  if (!res.ok) {
    let detail = "Something went wrong";
    try { detail = (await res.json()).detail || detail; } catch (e) { /* ignore */ }
    throw new Error(detail);
  }
  return res.json();
}

export const getProgress = () => call("/progress");
export const toggleItem = (item_id, checked) => call("/toggle", { method: "POST", body: { item_id, checked } });
export const clearLevel = (level) => call("/level-clear", { method: "POST", body: { level } });
export const completeCourse = () => call("/complete", { method: "POST" });
export const logEvent = (action, meta) => call("/log", { method: "POST", body: { action, meta } });
